var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-wrapper" },
    [
      _c("div", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))]),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid": _vm.formSubmitted && _vm.validation.$invalid
          }
        },
        [
          _c("md-input", {
            attrs: { placeholder: "Ex: 09-16-2019", type: "date" },
            on: { change: _vm.onDateChange },
            model: {
              value: _vm.date,
              callback: function($$v) {
                _vm.date = $$v
              },
              expression: "date"
            }
          }),
          _vm.formSubmitted && !_vm.validation.validDate
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("Invalid date format, please use MM-DD-YYYY")
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4414d222", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4414d222","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/DateInput.vue
// module id = 788
// module chunks = 0